import { EImportEntity }  from '../importer/model';
import { importReducer } from '../importer/reducer';

export const productsImport = importReducer(EImportEntity.PRODUCTS);
